module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Bold Italic.f90159e8.woff2";